import Image from "next/image";
import React, { FC, ReactNode } from "react";

import { ButtonWithIcon } from "@/components/atoms/buttons/ButtonWithIcon";

import PlusIcon from "/public/icon/plus.svg";

interface Props {
  text: string | ReactNode;
  button?: string;
  buttonHandle?: () => void;
  disabled?: boolean;
}

export const NoPostMessage: FC<Props> = ({ text, button, buttonHandle, disabled = false }) => {
  return (
    <div className="flex flex-col items-center mt-20 mb-9">
      <Image src="/user/icon/logo.svg" width="119" height="80" alt="Yoyacoo" />
      <p className="mt-4 text-[22px] font-bold md:text-xl">{text}</p>
      {button && buttonHandle && (
        <ButtonWithIcon
          icon={<PlusIcon className="w-4 h-4 fill-white" />}
          label={button}
          size="md"
          className="mt-9 md:inline-flex md:mt-10 md:w-auto"
          onClick={() => {
            !disabled && buttonHandle();
          }}
          disabled={disabled}
        />
      )}
    </div>
  );
};
